// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TermsOfService_content__9dKaT {
  padding: 5rem;
  max-width: 900px;
  margin: 0 auto;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
@media only screen and (max-width: 43.75em) {
  .TermsOfService_content__9dKaT {
    padding: 2rem;
  }
}

h2 {
  font-size: 2rem;
  font-weight: bold;
  color: #333;
}

p {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: #555;
  line-height: 1.6;
}

section h2 {
  font-size: 2rem;
  color: #222;
}

section p {
  font-size: 1.5rem;
  line-height: 1.8;
  color: #444;
}

footer {
  text-align: center;
  padding: 1rem 0;
  font-size: 0.9rem;
  color: #666;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/TermsOfService.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,wCAAA;AADD;AAGC;EARD;IASE,aAAA;EAAA;AACF;;AAGA;EACC,eAAA;EACA,iBAAA;EACA,WAAA;AAAD;;AAGA;EACC,iBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;AAAD;;AAGA;EACC,eAAA;EACA,WAAA;AAAD;;AAGA;EACC,iBAAA;EACA,gBAAA;EACA,WAAA;AAAD;;AAGA;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAAD","sourcesContent":["@import './variables/breakpoints';\n\n.content {\n\tpadding: 5rem;\n\tmax-width: 900px;\n\tmargin: 0 auto;\n\tbackground-color: #f9f9f9;\n\tborder-radius: 8px;\n\tbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\n\t@media only screen and (max-width: $bp-700) {\n\t\tpadding: 2rem;\n\t}\n}\n\nh2 {\n\tfont-size: 2rem;\n\tfont-weight: bold;\n\tcolor: #333;\n}\n\np {\n\tfont-size: 1.5rem;\n\tmargin-bottom: 1.5rem;\n\tcolor: #555;\n\tline-height: 1.6;\n}\n\nsection h2 {\n\tfont-size: 2rem;\n\tcolor: #222;\n}\n\nsection p {\n\tfont-size: 1.5rem;\n\tline-height: 1.8;\n\tcolor: #444;\n}\n\nfooter {\n\ttext-align: center;\n\tpadding: 1rem 0;\n\tfont-size: 0.9rem;\n\tcolor: #666;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `TermsOfService_content__9dKaT`
};
export default ___CSS_LOADER_EXPORT___;
